import * as React from "react";
const IconSurfBoard = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M43.2 2c-.7-.4-1.6-.4-2.3 0-3.3 1.7-6.4 4.4-8.9 7.9-2.5-3.5-5.6-6.2-8.9-7.9-.7-.4-1.6-.4-2.3 0C10.9 6.9 4.3 20.5 4.3 35.8c0 9.6 2.5 18.6 7.1 25.3.5.7 1.3 1.1 2.1 1.1h36.9c.9 0 1.7-.4 2.1-1.1 4.6-6.7 7.1-15.7 7.1-25.3.1-15.3-6.5-28.9-16.4-33.8M8.8 35.8c0-.9 0-1.9.1-2.8l24.8-8.8q.9 3.45 1.2 7.2L9 40.7c-.1-1.6-.2-3.2-.2-4.9M21.9 6.5c3.1 1.8 5.9 4.8 8.1 8.7.8 1.5 1.6 3.1 2.2 4.7L9.4 28.1c1.6-9.8 6.2-18 12.5-21.6m7.4 51.3H14.6c-2.3-3.6-3.9-7.9-4.9-12.6l25.4-9.1c0 7.5-1.8 14.7-5 20.3-.3.5-.6.9-.8 1.4m20.1 0H34.5c3.3-6.2 5.1-14 5.1-21.9s-1.8-15.5-5-21.7c2.1-3.4 4.7-6 7.5-7.6C50 11 55.2 22.7 55.2 35.8c0 8.3-2 16.1-5.8 22" />
  </svg>
);
export default IconSurfBoard;
